/**
 * TransactionsTable — F-009.3.
 *
 * Storico movimenti wallet: data, tipo, riferimento, importo firmato (verde se
 * positivo, rosso se negativo). Componente puro (nessuna rete) → testabile.
 */
import type { WalletTransactionItem } from '@app/shared';
import { centsToEuro, centsToNumber, formatDateTime, reasonLabel } from '../lib/format';

function AmountCell({ amountCents }: { amountCents: string }) {
  const n = centsToNumber(amountCents);
  const tone = n < 0 ? 'negative' : n > 0 ? 'positive' : 'zero';
  const cls =
    tone === 'negative'
      ? 'text-destructive'
      : tone === 'positive'
        ? 'text-emerald-600 dark:text-emerald-400'
        : '';
  return (
    <span className={`font-medium tabular-nums ${cls}`} data-amount-tone={tone}>
      {n > 0 ? '+' : ''}
      {centsToEuro(amountCents)}
    </span>
  );
}

export function TransactionsTable({ items }: { items: WalletTransactionItem[] }) {
  return (
    <table className="w-full border-collapse text-sm" aria-label="Storico movimenti wallet">
      <thead>
        <tr className="border-b text-left text-xs uppercase tracking-wide text-muted-foreground">
          <th scope="col" className="py-2 pr-4 font-medium">
            Data
          </th>
          <th scope="col" className="py-2 pr-4 font-medium">
            Tipo
          </th>
          <th scope="col" className="py-2 pr-4 font-medium">
            Riferimento
          </th>
          <th scope="col" className="py-2 text-right font-medium">
            Importo
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((tx) => (
          <tr key={tx.id} className="border-b last:border-0">
            <td className="py-2 pr-4 whitespace-nowrap">{formatDateTime(tx.createdAt)}</td>
            <td className="py-2 pr-4">{reasonLabel(tx.reason)}</td>
            <td className="py-2 pr-4 max-w-[16rem] truncate text-muted-foreground" title={tx.relatedId ?? undefined}>
              {tx.relatedId ?? '—'}
            </td>
            <td className="py-2 text-right">
              <AmountCell amountCents={tx.amountCents} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
